<template>
    <master-page icone="mdi-account-cash" titulo="CRM">

        <v-row class="mt-4">
            <v-col cols="12">
                <v-card>
                    <v-row dense>
                        <v-col cols="12" sm="9">
                            <v-card-title>
                                <span style="font-size: 22px; max-width: 350px; word-break: break-word !important">Filtros</span>
                            </v-card-title>
                            <v-card-subtitle>
                                <span style="font-size: 16px">Filtra as informações do dashboard.</span>
                            </v-card-subtitle>
                        </v-col>
                        <v-col cols="12" sm="3" style="display: flex; align-items: center; justify-content: center">
                            <v-btn color="primary" @click="GetCRM()">
                                <span style="color: white">Atualizar</span>
                            </v-btn>
                        </v-col>
                    </v-row>                        
                    <v-divider class="mt-2"/>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-select v-model="filtro.fonteId" label="Fonte" :items="fontes" item-value="key" item-text="value" dense outlined clearable/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select v-model="filtro.incentivoId" label="Lei Incentivo" :items="incentivos" item-value="key" item-text="value" dense outlined clearable/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select v-model="filtro.statusId" label="Status" :items="status" item-value="id" item-text="nome" dense outlined clearable/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-card flat class="mt-2" style="display: flex; align-items: center; justify-content: center">
            <v-card-text :style="$vuetify.breakpoint.mdAndDown ? 'width: 100vw' : 'width: 80vw'">
                <funel-chart id="FunelChart" title="Teste" :headers="crmLegenda" :data="crm" :text="valores"/>
            </v-card-text>
        </v-card>
        
        <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </master-page>
</template>

<script>
import ListPage from "@/components/shared/ListPage";
import Swal from 'sweetalert2';
import OportunidadeService from '../../core/services/doacao/OportunidadeService';
import OportunidadeLeiIncentivoEnumService from '../../core/services/doacao/OportunidadeLeiIncentivoEnumService';
import OportunidadeFonteEnumService from '../../core/services/doacao/OportunidadeFonteEnumService';

export default {
    extends: ListPage,
    data: () => ({
      primeiraCarga: false,
      crmLegenda: [
        "Prospecção",
        "Participação em edital",
        "Reunião Agendada",
        "Revisão do projeto",
        "Negociação",
        "Fechamento"
      ],
      valores: [],
      crm: [],
      filtro: {
        fonteId: null,
        incentivoId: null,
        statusId: null
      },
      fontes: [],
      incentivos: [],
      status: [
        { id: 'A', nome: "Aberto" },
        { id: 'F', nome: "Fechado" },
        { id: 'C', nome: "Cancelado" },
      ]
    }),
    watch:{
        
    },
    created() {
        this.GetCRM();
    },
    methods: {
        GetCRM(){
            this.primeiraCarga = true;
            this.crm = [];
            this.valores = [];
            new OportunidadeService().CRM(this.filtro.fonteId, this.filtro.incentivoId, this.filtro.statusId).then(
                res => {
                    var maior = 0;

                    this.valores.push(res.data.prospeccao);
                    this.valores.push(res.data.participacao);
                    this.valores.push(res.data.reuniao);
                    this.valores.push(res.data.revisao);
                    this.valores.push(res.data.negociacao);
                    this.valores.push(res.data.fechamento);

                    maior = Math.max(...this.valores);

                    this.crm.push([(maior / 2) - (res.data.prospeccao / 2), (maior / 2) + (res.data.prospeccao / 2), res.data.prospeccao]);
                    this.crm.push([(maior / 2) - (res.data.participacao / 2), (maior / 2) + (res.data.participacao / 2), res.data.participacao]);
                    this.crm.push([(maior / 2) - (res.data.reuniao / 2), (maior / 2) + (res.data.reuniao / 2), res.data.reuniao]);
                    this.crm.push([(maior / 2) - (res.data.revisao / 2), (maior / 2) + (res.data.revisao / 2), res.data.revisao]);
                    this.crm.push([(maior / 2) - (res.data.negociacao / 2), (maior / 2) + (res.data.negociacao / 2), res.data.negociacao]);
                    this.crm.push([(maior / 2) - (res.data.fechamento / 2), (maior / 2) + (res.data.fechamento / 2), res.data.fechamento]);
                }
            ).finally(() => {
                this.primeiraCarga = false;
            })

            new OportunidadeLeiIncentivoEnumService().Listar().then(
                res=>{
                    this.incentivos = res.data;
                },
                err => this.$swal('Aviso', err.message, 'error')
            )

            new OportunidadeFonteEnumService().Listar().then(
                res=>{
                    this.fontes = res.data;
                },
                err => this.$swal('Aviso', err.message, 'error')
            )
        },
        InformacaoTela(info){
            Swal.fire({
                html: info
            })
        },
        Atualizar(){
            
        }
    },
    mounted() {
        
    }
}
</script>
